import o from"./_Symbol.js";var t=o?o.prototype:void 0,r=t?t.valueOf:void 0;function e(o){return r?Object(r.call(o)):{}}export{e as default};
//# sourceMappingURL=_cloneSymbol.js.map
